﻿import BSN from "bootstrap.native";
import Search from "../app/search";

import "./style.scss";

BSN.initCallback(document.body);

const search = new Search("story-search");
search.init();



